import React from 'react';
import PropTypes from 'prop-types';

import ShadedColorPaletteHorizontal from './ShadedColorPaletteHorizontal';

const SingleShadedAreaLegendSimplified = props => {
    const { mapInstance, renderer } = props;
    const { fieldList, nullDataRuleIndex, insufficientDataRuleIndex, rules } = renderer;

    const legendHighlighted = rules.some(rule => rule.highlighted);

    return (
        <div className="horizontal-shaded-area-legend flex-it column grow">
            <ShadedColorPaletteHorizontal
                className="shaded-color-palette-horizontal"
                mapInstanceId={mapInstance.id}
                fields={fieldList.fields}
                nullDataRuleIndex={nullDataRuleIndex}
                insufficientDataRuleIndex={insufficientDataRuleIndex}
                rules={rules}
                showLabels
                legendHighlighted={legendHighlighted}
            />
        </div>
    );
};

SingleShadedAreaLegendSimplified.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    renderer: PropTypes.object.isRequired,
};

SingleShadedAreaLegendSimplified.defaultProps = {};

export default SingleShadedAreaLegendSimplified;
